module.exports = __webpack_public_path__ + "img/grand-cancun-beach-2.cd348c4e.jpg";